
export class Authenticate {
    public static readonly type = '[App] Authenticate';
    constructor(public logout: boolean = false) {
    }
}

